import { createAction } from "@reduxjs/toolkit";
import { SEND_ALL_USERS_NOTIFICATION } from "../constants";

export const sendGlobalPushNotification = createAction(SEND_ALL_USERS_NOTIFICATION);

export default {
  sendGlobalPushNotification
};
